/** Project IA reorganisation, P1 (2026-02) — small controlled tab bar for ProjectDashboard.jsx.
 * Plain buttons + state (not the shadcn/Radix Tabs primitive) to match this app's own existing
 * pill/chip button styling rather than shadcn's default theme, which nothing else on this page
 * uses. Purely presentational — panel content stays in ProjectDashboard.jsx itself since the
 * panels are page-specific, not reusable elsewhere.
 * Phase 4 (2026-10, Design System 2.0 visual reskin): tokens only — same 8 tabs, same keys,
 * same active-tab logic. The "Recce" tab's click now navigates to a full-screen route instead
 * of flipping a panel — that behaviour lives in ProjectDashboard.jsx's `onChange`, this
 * component stays a dumb `onChange(key)` caller either way. */
export const PROJECT_TABS = [
  { key: "overview", label: "Overview" },
  { key: "activity", label: "Activity" },
  { key: "workspace", label: "Workspace" },
  { key: "recce", label: "Recce" },
  { key: "deliverables", label: "Deliverables" },
  { key: "communication", label: "Communication" },
  { key: "commercial", label: "Commercial" },
  { key: "history", label: "History" },
];

// Wave R2 (2026-10): `tabs` is an optional override so ProjectDashboard.jsx can hide the
// "Recce" tab entirely for a viewer without client_portal.admin, instead of just gating its
// panel content (every other PROJECT_TABS entry is unconditionally visible, as before).
// Agency Portal Stabilisation Part B (2026-10), item 1: `badges` is an optional
// `{ [tabKey]: count }` map — a small count pill next to a tab's label, e.g. the
// "Communication" tab's unread-agency-comments badge. Every other tab/caller is unaffected
// (defaults to no badges at all).
export const ProjectPageTabs = ({ active, onChange, tabs = PROJECT_TABS, badges = {} }) => (
  <div className="flex items-center gap-1 rounded-md border border-hairline bg-paper px-2 overflow-x-auto" data-testid="project-page-tabs">
    {tabs.map((t) => (
      <button
        key={t.key}
        onClick={() => onChange(t.key)}
        data-testid={`project-tab-${t.key}`}
        data-active={active === t.key}
        className={`shrink-0 px-4 py-3 text-[12.5px] font-bold uppercase tracking-wide border-b-2 transition-colors ${
          active === t.key
            ? "border-brand text-ink"
            : "border-transparent text-faint hover:text-ink-soft"
        }`}
      >
        {t.label}
        {badges[t.key] > 0 && (
          <span className="ml-1.5 inline-flex items-center justify-center rounded-full bg-amber-500 text-white text-[10px] font-bold min-w-[16px] h-[16px] px-1" data-testid={`project-tab-badge-${t.key}`}>
            {badges[t.key]}
          </span>
        )}
      </button>
    ))}
  </div>
);
